module.exports = __webpack_public_path__ + "static/media/ball_d.d2390337.png";